module.exports = __webpack_public_path__ + "static/media/dumb_rick.b2d4c98d.png";